import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'

export const GoogleMapURL = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [gMapUrl, setGMapUrl] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setGMapUrl(branchList?.find(branch => branch.Intern === branchId)?.GoogleMapURL || '')
    }
  }, [branchList?.length, branchId])

  const updateGMapUrl = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.GoogleMapURL !== gMapUrl) {
      updateBranch({ GoogleMapURL: gMapUrl })
    }
  }

  return (
    <Input label='Google Map URL' onChange={setGMapUrl} onBlur={updateGMapUrl} value={gMapUrl} />
  )
}
